export const GET_CLASSIFICATION = 'GET_CLASSIFICATION';
export const LOADING_CLASSIFICATION = 'LOADING_CLASSIFICATION';
export const SAVE_LOADER_CLASSIFICATION = 'SAVE_LOADER_CLASSIFICATION'
export const FORM_FAIL = "FORM_FAIL";
export const CLASSIFICATION_FAIL = 'CLASSIFICATION_FAIL';